import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export const initialState: ProductDomain.State = {
	startedInitAndLink: false,
	reInitAndLink: false,
	activeModifierGroup: -1,
	activeModifierScale: -1,
	isProductVersionOptionActive: false,
	isSizeOptionActive: false,
	loadingQueue: [],
	initAndLinkProgress: 0,
	initAndLinkProgressMessage: 'Downloading menu data...',
	modifying: false,
	transactionLoaded: false,
	percomatic: {
		ui: {
			homeScreenHandler: {
				orderScreenHandler: {
					componentQuantities: [],
					processingCreditCard: false,
					selectedItemIndex: -1,
					ticketPayments: [],
					ticketItems: {
						transItems: []
					},
					modifyScreenHandler: {
						productVersions: {
							productVersions: [],
							selectedIndex: -1
						},
						sizes: {
							sizes: [],
							selectedIndex: -1
						}
					}
				}
			}
		}
	}
};

const slice = createSlice({
	name: 'productSlice',
	initialState: initialState,
	reducers: {
		reInitAndLink: (state: ProductDomain.State) => {
			state.reInitAndLink = true;
			state.startedInitAndLink = false;
		},
		setStartedInitAndLink: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { reInitAndLink, startedInitAndLink } = action.payload;

			state.reInitAndLink = reInitAndLink ? false : reInitAndLink;
			state.startedInitAndLink = startedInitAndLink;
		},
		initAndLinkComplete: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			state.modifying = initialState.modifying;
			state = action.payload;
		},
		uploadLoadingQueue: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { loadingQueue } = action.payload;
			state.loadingQueue = loadingQueue;
		},
		uploadInitProgress: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { loadingQueue } = action.payload;
			const newProgress = loadingQueue.shift();

			state = {
				...state,
				loadingQueue,
				...newProgress
			};
		},
		clickModifierGroup: (state: ProductDomain.State) => {
			state.activeModifierGroup = -1;
			state.activeModifierScale = -1; // biggby***
			state.isProductVersionOptionActive = false;
			state.isSizeOptionActive = false;
		},
		clickModifierScale: (state: ProductDomain.State) => {
			state.activeModifierGroup = -1;
			state.activeModifierScale = -1; // biggby***
			state.isProductVersionOptionActive = false;
			state.isSizeOptionActive = false;
		},
		clickSize: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { isSizeOptionActive } = action.payload;

			state.activeModifierGroup = -1;
			state.activeModifierScale = -1;
			state.isProductVersionOptionActive = false;
			state.isSizeOptionActive = !isSizeOptionActive;
		},
		clickProductVersion: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { isProductVersionOptionActive } = action.payload;

			state.activeModifierGroup = -1;
			state.activeModifierScale = -1;
			state.isProductVersionOptionActive = !isProductVersionOptionActive;
			state.isSizeOptionActive = false;
		},
		startModifying: (state: ProductDomain.State) => {
			state.modifying = true;
		},
		stopModifying: (state: ProductDomain.State) => {
			state.modifying = false;
		},
		selectProduct: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { percomatic } = action.payload;
			state.percomatic = percomatic;
		},
		loadTransaction: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { percomatic } = action.payload;
			state.percomatic = percomatic;
			state.transactionLoaded = true;
			state.modifying = false;
		},
		selecteModifier: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			const { percomatic } = action.payload;
			state.percomatic = percomatic;
			state.modifying = false;
		},
		setSaving: (
			state: ProductDomain.State,
			action: PayloadAction<ProductDomain.State>
		) => {
			state.modifying = action.payload.modifying;
		}
	}
});

export const productReducer = slice.reducer;
export const {
	reInitAndLink,
	setStartedInitAndLink,
	initAndLinkComplete,
	uploadLoadingQueue,
	uploadInitProgress,
	clickModifierGroup,
	clickModifierScale,
	clickSize,
	clickProductVersion,
	startModifying,
	stopModifying,
	selectProduct,
	loadTransaction,
	selecteModifier,
	setSaving
} = slice.actions;
